import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider, useTheme } from "./components/ThemeProvider";
import SmoothScroll from "./components/SmoothScroll";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import PainPoints from "./components/PainPoints";
import Founders from "./components/Founders";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function Home() {
  return (
    <main className="grain relative" data-testid="home-page">
      <Nav />
      <Hero />
      <PainPoints />
      <Founders />
      <Contact />
      <Footer />
    </main>
  );
}

function ThemedToaster() {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        style: {
          background: isDark ? "#F1ECE3" : "#2C2621",
          color: isDark ? "#1A1620" : "#F7F5F0",
          border: isDark ? "1px solid #d8d2c5" : "1px solid #3a322c",
          fontFamily: "Outfit, sans-serif",
        },
      }}
    />
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <SmoothScroll />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <ThemedToaster />
      </div>
    </ThemeProvider>
  );
}

export default App;
